import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import { IPopularDirectionsAvia } from './model'

export const PopularDirectionsAvia = {
  getPopularDestinations() {
    return clientApi.get<Response<IPopularDirectionsAvia[]>>(
      'flights/popular-destinations',
    )
  },
}
